module.exports = "TickTock example\n\nTo work we have to do 2 things\n&nbsp;&nbsp;&nbsp;&nbsp;- Pass in current time\n&nbsp;&nbsp;&nbsp;&nbsp;- Call `tick` function to render\n\nEncapsulate this functionality?\n\nIdeal clock component?\n\n&nbsp;&nbsp;&nbsp;&nbsp;- Know the time\n&nbsp;&nbsp;&nbsp;&nbsp;- Tick on its own\n&nbsp;&nbsp;&nbsp;&nbsp;- Start when rendered"


//////////////////
// WEBPACK FOOTER
// ./src/slides/10_components/notes_4.md
// module id = 1521
// module chunks = 0